<template>
  <v-dialog v-model="dialog" width="35%" persistent>
    <v-card style="border-radius: 7px">
      <v-toolbar dense>
        <v-toolbar-title class="title">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container class="mr-3 mt-2">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              label="Idea Title"
              :rules="[value => !!value || 'Title is Required.', v => (v || '' ).length <= 20 || 'Description must be 20 characters or less']"
              v-model="editedIdea.title"
              required
              color="black"
              outlined
            ></v-text-field>
            <v-textarea
              outlined
              v-model="editedIdea.description"
              color="black"
              label="Idea Description"
              :rules="[value => !!value || 'Description is Required.']"
              required
              class="mb-0 pb-0"
            ></v-textarea>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions class="mx-5 px-5">
        <v-row justify="end" class="mb-5">
          <v-btn
            color="success"
            class="elevation-10 black--text"
            outlined
            rounded
            dark
            @click="saveIdea"
          >
            <span class="mx-4 subheading">{{ btnName }}</span>
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      valid: true
    };
  },
  computed: {
    ...mapState("idea", ["dialog", "editedIdea", "defaultIdea"]),
    title() {
      if (!this.editedIdea._id) {
        return "Create New Idea";
      } else {
        return "Update Idea";
      }
    },
    btnName() {
      if (!this.editedIdea.id) {
        return "Save";
      } else {
        return "Update";
      }
    }
  },
  methods: {
    ...mapActions("idea", ["create"]),
    ...mapMutations("idea", ["setDialog", "clearEditedIdea"]),
    saveIdea() {
      if (this.$refs.form.validate()) {
        this.create(this.editedIdea);
        this.closeDialog();
      }
    },
    closeDialog() {
      this.setDialog(false);
      setTimeout(() => {
        this.clearEditedIdea();
      }, 600);
    }
  }
};
</script>